<template>
    <el-row class="ipblacklist container_self table_parent">
        <h3>域名白名单列表</h3>
        <el-row class="search_parent">
            <el-form :inline="true" size="mini" :model="queryParams" class="demo-form-inline queryForm">
                <el-form-item label="域名">
                    <el-input v-model="queryParams.keyword" placeholder="请输入域名" clearable></el-input>
                </el-form-item>
                <!-- <el-form-item label="域名">
                    <el-select v-model="queryParams.enabled" placeholder="请选择状态" clearable>
                        <el-option label="启用" :value="0"></el-option>
                        <el-option label="未启用" :value="1"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="开始时间">
                    <el-date-picker
                        v-model="queryParams.startTime"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        clearable
                        placeholder="选择开始时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间">
                    <el-date-picker
                        v-model="queryParams.endTime"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        clearable
                        placeholder="选择结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>
        </el-row>
        <el-table :data="whiteList"  style="width: 100%" v-loading="loading">
           <el-table-column prop="id" label="ID" align="center" width="50"></el-table-column>
           <el-table-column prop="dm" label="域名" align="center"></el-table-column>
           <el-table-column label="是否启用" align="center">
                <template slot-scope="scope">
                     <span v-if="!scope.row.disabled">启用</span>
                     <span v-else>未启用</span>
                </template>
           </el-table-column>
           <el-table-column prop="source" label="问题来源" align="center"></el-table-column>
           <el-table-column prop="description" label="问题描述" align="center" width="700"></el-table-column>
           <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
           <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <!-- <el-button type="success" size="mini" @click="setItem(scope.row)">设置</el-button> -->
                    <el-button type="danger" size="mini" @click="deleteItem(scope.row)">删除</el-button>
                </template>
           </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryParams.currentPage"
            :page-sizes="[50, 100, 200, 400]"
            :page-size="queryParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>


        <!-- <el-dialog title="更新白名单域名信息" :visible.sync="dialogFormVisible">
            <el-form :model="setWhiteList" size="mini">
                <el-form-item label="域名" :label-width="formLabelWidth">
                    <el-input v-model="setWhiteList.dm" autocomplete="off" disabled></el-input>
                </el-form-item>
                <el-form-item label="问题描述" :label-width="formLabelWidth">
                    <el-input v-model="setWhiteList.description" autocomplete="off"></el-input>
                </el-form-item>
              
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateIpStatus">确 定</el-button>
            </div>
        </el-dialog> -->
    </el-row>
</template>

<script>
    import {axiosGet,axiosPost} from '@/assets/ajaxFn'
    export default {
        data(){
            return{
                whiteList:[],
                queryParams:{
                    currentPage:1,
                    endTime:"",
                    keyword:"",
                    pageSize:50,
                    startTime:"",
                    type:0,
                    enabled:""
                },
                setWhiteList:{
                    action:0,
                    description:"",
                    dm:"",
                    source: "",
                    type:0
                },
                total:0,
                dialogFormVisible:false,
                formLabelWidth:"80px",
                loading:false,
            }
        },
        methods: {
            async getList(params){
                this.loading=true;
                await axiosGet('/api/ip_fraud_rate/dm_white_black_list',params).then(res=>{
                    if(res.code==0){
                        this.whiteList=res.data.records;
                        this.total=res.total;
                    }
                })
                this.loading=false;
            },
            onSubmit(){
                this.queryParams.currentPage=1;
                this.queryParams.pageSize=50;
                this.getList(this.queryParams);
            },
            handleSizeChange(val){//下拉翻页
                this.queryParams.pageSize=val;
                this.getList(this.queryParams);
            },
            handleCurrentChange(val){//页码翻页
                this.queryParams.currentPage=val;
                this.getList(this.queryParams);
            },
            setItem(item){
                this.setWhiteList={
                    dm:item.dm,
                    source: item.source,
                    description:item.description
                };
                this.dialogFormVisible=true;
            },
            deleteItem(row){
                this.$confirm('请确认是否要从白名单里删除此IP?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        axiosPost('/api/ip_fraud_rate/add_dm_white_black',{action:3,dm:row.dm},"JSON").then(res=>{
                           if(res.code==0){
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            this.getList(this.setWhiteList);   
                           }
                        })
                    }).catch(() => {});
            },
            updateIpStatus(){
                if(!this.setWhiteList.action){
                    this.$message({message:"请先选择需要进行的设置",type:"error"}); 
                    return false;
                }
                let _this=this;
                axiosPost('/api/ip_fraud_rate/add_ipblack',_this.setWhiteList,"JSON").then(res=>{
                    if(res.code==0){
                        _this.getList(_this.setWhiteList);
                        _this.$message({message:"设置成功",type:"success"});
                        
                        _this.dialogFormVisible=false;
                    }else{
                        _this.$message({message:res.message,type:"error"});
                        _this.dialogFormVisible=false;
                    }
                })
            }
        },
        mounted() {
            this.getList(this.queryParams)
        },
    }
</script>

<style scope>
    .queryForm{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/view/IpManager/whiteList.vue